// src/components/CartItem.js
import React from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../services/api";

function CartItem({ item, lang }) {
  const { changeQty, removeFromCart } = useCart();
  const navigate = useNavigate();

const isOutOfStock = !item.is_available;

  const goToProduct = () => {
    if (!item.slug) return;

    apiRequest("/analytics/track", {
      method: "POST",
      body: JSON.stringify({
        action_type: "view_product",
        entity_type: "product",
        entity_id: item.product_id,
      }),
    }).catch(() => {});

    navigate(`/product/${item.slug}`);
  };

  return (
    <div
      onClick={goToProduct}
      role="button"
      tabIndex={0}
      className="
        cursor-pointer
        w-full flex gap-4 p-4 
        bg-black text-white
        border border-[rgba(46,150,42,0.35)]
        rounded-lg
        shadow-[0_0_15px_rgba(46,150,42,0.15)]
        hover:shadow-[0_0_22px_rgba(46,150,42,0.35)]
        transition-all relative
      "
    >
      {/* OUT OF STOCK RIBBON */}
      {isOutOfStock && (
        <div
          className="
            absolute -left-10 top-4
            rotate-[-45deg]
            bg-red-700 text-white
            text-xs font-bold
            px-10 py-1
            shadow-md
            pointer-events-none
          "
        >
          {lang === "EN" ? "OUT OF STOCK" : "نفد المخزون"}
        </div>
      )}

      {/* IMAGE */}
      <img
        src={item.image}
        className="
          w-24 h-24 object-cover rounded-md
          border border-[rgba(46,150,42,0.35)]
        "
        alt={lang === "EN" ? item.nameEN : item.nameAR}
      />

      {/* DETAILS */}
      <div className="flex flex-col flex-1">
        <p className="font-semibold leading-tight pr-6">
          {lang === "EN" ? item.nameEN : item.nameAR}
        </p>

        {item.public_id && (
          <p className="text-[11px] text-gray-400 mt-[2px]">
            {item.public_id}
          </p>
        )}

        {/* COLOR + SIZE */}
        {(item.color || item.size) && (
          <div className="flex items-center gap-3 mt-1">
            {item.color && (
              <div
                className="
                  w-3.5 h-3.5 rounded-full
                  border border-[rgba(255,255,255,0.4)]
                "
                title={item.color}
                style={{ backgroundColor: item.color }}
              />
            )}

            {item.size && (
              <span
                className="
                  text-[11px] px-2 py-[2px]
                  rounded-full
                  border border-[rgba(46,150,42,0.5)]
                  text-[#2E5A2A]
                  font-medium
                "
              >
                {lang === "EN" ? `Size ${item.size}` : `مقاس ${item.size}`}
              </span>
            )}
          </div>
        )}

        {/* PRICE */}
        <p className="font-bold text-[#2E5A2A] mt-1">
          ${item.price}
        </p>


        {/* QTY + REMOVE */}
        <div className="flex items-center justify-between mt-4">
          {/* QTY SELECTOR */}
          <div
            className="
              flex items-center
              border border-[rgba(46,150,42,0.35)]
              rounded-full
              px-3 py-1
              bg-black
            "
          >
            <button
              className="text-lg px-2 opacity-70 hover:opacity-100"
              disabled={isOutOfStock}
              onClick={(e) => {
                e.stopPropagation();
                !isOutOfStock && changeQty(item.id, -1);
              }}
            >
              −
            </button>

            <span
              className={`mx-3 font-medium ${
                isOutOfStock ? "text-red-500" : ""
              }`}
            >
              {item.qty}
            </span>

            <button
className={`text-lg px-2 ${
  isOutOfStock
    ? "opacity-30 cursor-not-allowed"
    : "opacity-70 hover:opacity-100"
}`}
disabled={isOutOfStock}
onClick={(e) => {
  e.stopPropagation();
  !isOutOfStock && changeQty(item.id, 1);
}}

            >
              +
            </button>
          </div>

          {/* REMOVE */}
          <button
            className="text-xl opacity-60 hover:opacity-100 transition"
            onClick={(e) => {
              e.stopPropagation();
              removeFromCart(item.id);
            }}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartItem;
